import {
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
} from '@chakra-ui/react';
import * as React from 'react';

import { BlogEdit } from './components/BlogEdit';

export const PostingDrawer: React.FC<{
  isDrawerOpen: boolean;
  onDrawerClose: () => void;
  options?: {
    group?: { _id: string };
    tags?: { _id: string; name: string }[];
    postId?: string;
    organization?: { _id: string };
    showFixedGroupName?: boolean;
  };
}> = (props) => {
  return (
    <Drawer
      placement="right"
      isOpen={props.isDrawerOpen}
      onClose={props.onDrawerClose}
      size="lg"
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton
          zIndex="docked"
          bg="white"
          _hover={{ bg: 'gray.100' }}
          borderRadius="full"
        />
        <BlogEdit
          postId={props.options?.postId}
          tags={props.options?.tags ? props.options.tags : []}
          closeModal={props.onDrawerClose}
          group={props.options?.group}
          organization={props.options?.organization}
          showFixedGroupName={
            props.options?.organization
              ? false
              : !!props.options?.showFixedGroupName
          }
        />
      </DrawerContent>
    </Drawer>
  );
};
